import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { CABIN_CREW_BUS_ASSIGNMENT_PATH } from '../../../../config/paths';

const EditCabinCrewBusAssignmentButton = ({ cabinCrewBusAssignmentId }) => (
  <Link
    className="btn btn-primary"
    to={`${CABIN_CREW_BUS_ASSIGNMENT_PATH}/${cabinCrewBusAssignmentId}/edit`}
  >
    Editar
  </Link>
);

EditCabinCrewBusAssignmentButton.propTypes = {
  cabinCrewBusAssignmentId: PropTypes.number.isRequired,
};

export default EditCabinCrewBusAssignmentButton;
